import { Schema, DynamicContentSchemaFactory, FilterPagination } from '../../../services';
import { map } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs';
import { Injectable } from '@angular/core';
import {SiteSettingFacade } from '../../../services';
import { ESchemaContentStatus } from '../../../services/akita/base/enum';

@Injectable({
  providedIn: 'root'
})
export class FieldReferenceContent {

  constructor(
    private readonly contentFacadeFacto: DynamicContentSchemaFactory,
    private readonly siteSettingFacade: SiteSettingFacade
  ) { }

  sortByIndex(a, b) {

    if (!a || !a.data || !b || !b.data) {
      return 0;
    }

    if (a.data.index && b.data.index) {
      if (a.data.index.iv < b.data.index.iv)
        return -1;
      if (a.data.index.iv > b.data.index.iv)
        return 1;
    }

    if (a.data.Name && b.data.Name) {
      if (a.data.Name.iv < b.data.Name.iv)
        return -1;
      if (a.data.Name.iv > b.data.Name.iv)
        return 1;
    }

    return 0;
  }

  generateContentList( schemaDefinition: Schema): Observable<any> {

    const result = {};
    const referenceFields = schemaDefinition.fields.filter(field => field.properties.fieldType === 'References');

    const obsList: Observable<any>[] = [];

    if (referenceFields && referenceFields.length > 0) {

      referenceFields.forEach(field => {
        if (!result[field.name]) {
          result[field.name] = [];
        }

      const filter = new FilterPagination();

      filter.from = 0;
      filter.to = 2000;
        if (field.properties.schemaIds && field.properties.schemaIds.length > 0) {
          const service = this.contentFacadeFacto.getDynamicContentSchemaFacade(field.properties.schemaIds[0]);
            obsList.push(service.getFilteredPagination(filter, ESchemaContentStatus.Published).pipe(map(contents => {
            contents.sort(this.sortByIndex).forEach(content => {
              let label :string;

              if (content.data.Name) {
                label = content.data.Name[this.siteSettingFacade.getCurrentLanguage()];
                if (!label) {
                  label = content.data.code.iv;
                }
              } else
              {
                label = content.data.code.iv;
              }

              result[field.name].push({
                Id: content.id,
                Code: content.data.code.iv,
                Label: label
              });
            });

          })));
        }

      });
    }
    if (referenceFields.length === 0) {
      return of({});
    }

    return combineLatest(obsList).pipe(map(([i]) => {
      return result;
    }));
  }

  generateContentListUnknown(schemaDefinition: any): Observable<any> {

    const result = {};
    const referenceFields = schemaDefinition.fields.filter(field => field.properties.fieldType === 'References');

    const obsList: Observable<any>[] = [];

    if (referenceFields && referenceFields.length > 0) {

      referenceFields.forEach(field => {
        if (!result[field.name]) {
          result[field.name] = [];
        }

        const filter = new FilterPagination();

        filter.from = 0;
        filter.to = 2000;
        if (field.properties.schemaIds && field.properties.schemaIds.length > 0) {
          const service = this.contentFacadeFacto.getDynamicContentSchemaFacade(field.properties.schemaIds[0]);
          obsList.push(service.getFilteredPagination(filter, ESchemaContentStatus.Published).pipe(map(contents => {
            contents.sort(this.sortByIndex).forEach(content => {
              let label: string;

              if (content.data.Name) {
                label = content.data.Name[this.siteSettingFacade.getCurrentLanguage()];
                if (!label) {
                  label = content.data.code.iv;
                }
              } else {
                label = content.data.code.iv;
              }

              result[field.name].push({
                Id: content.id,
                Code: content.data.code.iv,
                Label: label
              });
            });

          })));
        }

      });
    }
    if (referenceFields.length === 0) {
      return of({});
    }

    return combineLatest(obsList).pipe(map(([i]) => {
      return result;
    }));
  }


}

